import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Theme from '../../Theme/index.js';

var _templateObject;
var Message = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n"])), Theme.colors.danger);
var ErrorText = function ErrorText(_ref) {
  var errors = _ref.errors,
    touched = _ref.touched,
    field = _ref.field;
  return touched[field] && errors[field] ? /*#__PURE__*/React__default.createElement(Message, null, errors[field]) : null;
};
ErrorText.propTypes = {
  errors: PropTypes.object,
  touched: PropTypes.object,
  field: PropTypes.string
};

export { ErrorText as default };
